/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HealthService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Health check endpoint
   * Verifica el estado de salud de la aplicación incluyendo base de datos, memoria y disco. Endpoint público para uso de balanceadores de carga y sistemas de monitoreo.
   * @returns any The Health Check is successful
   * @throws ApiError
   */
  public healthControllerCheck(): CancelablePromise<{
    status?: string;
    info?: Record<string, Record<string, any>> | null;
    error?: Record<string, Record<string, any>> | null;
    details?: Record<string, Record<string, any>>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/health',
      errors: {
        503: `The Health Check is not successful`,
      },
    });
  }
}
